<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Background />

    <Header
      :showGoBack="true"
      :title="'Open moneybox'"
    />

    <main
      :class="'scrollable container'"
      :style="{paddingTop: '10px', paddingBottom: '10px'}"
    >
      <!-- The amount you want to achieve -->
      <section :style="{marginBottom: '30px'}">
        <span
          :class="'t14'"
          :style="{marginBottom: '10px', display: 'block'}"
          >The amount you want to achieve</span
        >
        <Input
          :leftIcon="DollarSvg"
          :placeholder="'Enter the amount'"
          :containerStyle="{marginBottom: '10px'}"
        />
        <Input
          :leftIcon="InputEditSvg"
          :placeholder="'Enter your goal'"
        />
      </section>

      <!-- Use card -->
      <section :style="{marginBottom: '30px'}">
        <span
          :class="'t14'"
          :style="{display: 'block', marginBottom: '10px'}"
          >Use card</span
        >
        <ul>
          <li
            v-for="(card, index) in cards"
            :key="card.id"
            :style="{
              gap: '12px',
              padding: '12px',
              borderRadius: '10px',
              border: '1px solid #FFEFE6',
              backgroundColor: 'var(--white-color)',
              borderColor: selectedCard === card.id ? '#6C6D84' : '#FFEFE6',
              marginBottom: index === cards.length - 1 ? '0' : '10px',
            }"
            @click="setCard(card.id)"
            :class="'row-center clickable'"
          >
            <img
              :src="card.image"
              alt="card"
              :style="{width: '62px', height: 'auto', borderRadius: '6px'}"
            />
            <div :class="'column-start'">
              <span :class="'t12'">{{ card.number }}</span>
              <h6
                :class="'t14'"
                :style="{color: 'var(--main-dark)'}"
              >
                Balance: {{ card.balance }} USD
              </h6>
            </div>
          </li>
        </ul>
      </section>

      <!-- Amount per day -->
      <section>
        <div
          @click="setAmountPerDay"
          :class="'clickable row-center'"
          :style="{marginBottom: '10px', gap: '12px'}"
        >
          <div
            :style="{
              width: '18px',
              height: '18px',
              borderRadius: '50%',
              border: '1px solid var(--main-dark)',
            }"
            :class="'center'"
          >
            <div
              v-if="selectedAmountPerDay"
              :style="{
                width: '10px',
                height: '10px',
                borderRadius: '2px',
                borderRadius: '50%',
                backgroundColor: '#55ACEE',
              }"
            />
          </div>
          <span :class="'t14'">Amount per day</span>
        </div>
        <Input
          :leftIcon="DollarSvg"
          :placeholder="'Enter the amount'"
          :containerStyle="{marginBottom: '17px'}"
        />

        <!-- Rounding up -->
        <ul
          :class="'row-center'"
          :style="{gap: '17px'}"
        >
          <li
            :style="{
              width: '100%',
              padding: '16px',
              borderRadius: '10px',
              border: '1px solid #FFEFE6',
              backgroundColor: 'var(--white-color)',
            }"
            :class="'clickable'"
            @click="setRoundingUp('1')"
          >
            <!-- Button -->
            <div
              :style="{
                width: '18px',
                height: '18px',
                borderRadius: '50%',
                marginBottom: '8px',
                border: '1px solid var(--main-dark)',
              }"
              :class="'center'"
            >
              <div
                v-if="selectedRoundingUp === '1'"
                :style="{
                  width: '10px',
                  height: '10px',
                  borderRadius: '2px',
                  borderRadius: '50%',
                  backgroundColor: '#55ACEE',
                }"
              />
            </div>
            <p
              :class="'t14'"
              :style="{color: 'var(--main-dark)'}"
            >
              Rounding up to $1 <br />
              per transaction.
            </p>
          </li>
          <li
            :style="{
              width: '100%',
              padding: '16px',
              borderRadius: '10px',
              border: '1px solid #FFEFE6',
              backgroundColor: 'var(--white-color)',
            }"
            :class="'clickable'"
            @click="setRoundingUp('10')"
          >
            <!-- Button -->
            <div
              :style="{
                width: '18px',
                height: '18px',
                borderRadius: '50%',
                marginBottom: '8px',
                border: '1px solid var(--main-dark)',
              }"
              :class="'center'"
            >
              <div
                v-if="selectedRoundingUp === '10'"
                :style="{
                  width: '10px',
                  height: '10px',
                  borderRadius: '2px',
                  borderRadius: '50%',
                  backgroundColor: '#55ACEE',
                }"
              />
            </div>
            <p
              :class="'t14'"
              :style="{color: 'var(--main-dark)'}"
            >
              Rounding up to $10 <br />
              per transaction.
            </p>
          </li>
        </ul>
      </section>
    </main>

    <!-- Button -->
    <section :style="{padding: '20px'}">
      <Button
        :title="'Open Moneybox'"
        :onClick="() => $router.push(routes.TAB_NAVIGATOR)"
      />
    </section>
  </div>
</template>

<script setup>
// others
import {ref} from 'vue';
import {routes} from '@/routes';
import {useOpacity} from '@/hooks';

// svg
import {DollarSvg} from '@/assets/svg';
import {InputEditSvg} from '@/assets/svg';

// components
import {Input} from '@/components';
import {Header} from '@/components';
import {Button} from '@/components';
import {Background} from '@/components';

const opacity = useOpacity();

const cards = [
  {
    id: 1,
    number: '**** **** **** 7895',
    balance: '4 863.27',
    image: require('@/assets/cards/01.jpg'),
  },
  {
    id: 2,
    number: '**** **** **** 7895',
    balance: '4 863.27',
    image: require('@/assets/cards/02.jpg'),
  },
];

const selectedRoundingUp = ref('');
const selectedCard = ref(cards[0].id);
const selectedAmountPerDay = ref(false);

const setCard = (id) => {
  selectedCard.value = id;
};

const setRoundingUp = (value) => {
  selectedRoundingUp.value = value;
};

const setAmountPerDay = () => {
  selectedAmountPerDay.value = !selectedAmountPerDay.value;
};
</script>
